<template>
  <div id="myDay">
    <nav-bar>
      <input
        slot="center"
        class="search"
        type="text"
        placeholder="添加todo"
        v-model="inputValue"
        @keyup.enter="addItem"
      />
    </nav-bar>
    <task-bar class="todo">
      <span
        slot="tagging"
        @mouseover="showDetailM('todo')"
        @mouseout="hideDetailM('todo')"
        @click="clearItem(false)"
      >
        ToDo({{ todoCount }})
        <show-detail
          text="点我清空"
          :display="displayTodo"
          top="0.2rem"
          left="1rem"
        ></show-detail>
      </span>
      <span v-if="!todoCount">你还添加任何待办</span>
      <transition-group name="ani">
        <list-item
          v-for="(item, index) in mydayList"
          :key="item.tid"
          v-show="!item.done"
          :item="item.title"
          :done="item.done"
          @deleteItem="deleteItem(index)"
          @isDone="isDone(index)"
        ></list-item>
      </transition-group>
    </task-bar>
    <task-bar class="done">
      <!-- <task-bar :tagging="'Done' + '(' + doneCount + ')'" class="done" > -->
      <span
        slot="tagging"
        @mouseover="showDetailM('done')"
        @mouseout="hideDetailM('done')"
        @click="clearItem(true)"
      >
        Done({{ doneCount }})
        <show-detail
          text="点我清空"
          :display="displayDone"
          top="0.2rem"
          left="1rem"
        ></show-detail>
      </span>
      <span v-if="!doneCount">你还未完成任何待办</span>
      <transition-group name="ani">
        <list-item
          v-for="(item, index) in mydayList"
          :key="item.tid"
          v-show="item.done"
          :item="item.title"
          :done="item.done"
          @deleteItem="deleteItem(index)"
          @isDone="isDone(index)"
        ></list-item>
      </transition-group>
    </task-bar>
  </div>
</template>

<script>
import NavBar from "components/common/navbar/NavBar.vue";
import TaskBar from "components/content/taskbar/TaskBar.vue";
import ListItem from "components/content/listItem/ListItem.vue";
import ShowDetail from "components/content/showDetail/ShowDetail.vue";

import {
  getData,
  saveData,
  deleteData,
  getDateStr,
} from "assets/js/todoList.js";

export default {
  name: "MyDay",
  components: {
    NavBar,
    TaskBar,
    ListItem,
    ShowDetail,
  },
  data() {
    return {
      mydayList: [
        // {title: '🍎吃苹果', done: false, createDate: "2021-03-26"},
        // {title: '🍓吃草莓', done: false, createDate: "2021-03-26"},
        // {title: '🍌吃香蕉', done: false, createDate: "2021-03-26"},
        // {title: '🍈吃橘子', done: false, createDate: "2021-03-26"},
        // {title: '🍉吃西瓜', done: false, createDate: "2021-03-26"},
      ],
      inputValue: "",
      dateNow: "",
      displayTodo: "none",
      displayDone: "none",
    };
  },
  computed: {
    //未完成数量
    todoCount() {
      return this.mydayList.filter((item) => {
        return !item.done;
      }).length;
    },

    //已完成数量
    doneCount() {
      return this.mydayList.filter((item) => {
        return item.done;
      }).length;
    },
  },
  // 页面加载即渲染所有数据
  created() {
    let allList = getData("myday");

    //得到当前时间
    this.dateNow = getDateStr();
    let data = getData("myNoTodo");

    // 不可行
    // allList.forEach((item, index) => {
    //   if(item.createDate !== this.dateNow) {
    //     data.push(item)
    //     // allList.splice(index, 1) //不可行，index 在allList被删的过程中改变了
    //     console.log(index)
    //     this.mydayList.splice(index, 1)
    //   }
    // })
    // allList = this.mydayList

    // 分类数据
    allList = allList.filter((item, index) => {
      if (item.createDate !== this.dateNow && !item.done) {
        data.push(item);
      } else {
        return item;
      }
    });

    this.mydayList = allList;

    saveData(allList, "myday");
    // this.mydayList = allList
    saveData(data, "myNoTodo");
  },

  //监听数据变化
  watch: {
    mydayList: {
      // 该回调会在任何被侦听的对象的 mydayList 改变时被调用，不论其被嵌套多深
      handler() {
        saveData(this.mydayList, "myday");
        getData();
      },
      deep: true,
    },
  },

  methods: {
    // 添加
    addItem(e) {
      let data = e.target.value;
      if (data === "") {
        return alert("请输入待办");
      }
      const createDate = getDateStr();
      const tid = new Date().valueOf();
      this.mydayList.push({ title: data, done: false, createDate, tid });
      this.inputValue = "";
    },
    //删除
    deleteItem(index) {
      this.mydayList.splice(index, 1);
    },
    // 清除待办
    clearItem(done) {
      let sure = confirm("确定清空该类待办？");
      if (sure) {
        this.mydayList = this.mydayList.filter((item) => {
          return item.done !== done;
        });
      }
    },
    //完成
    isDone(index) {
      this.mydayList[index].done = !this.mydayList[index].done;
    },
    // 展示提示信息
    showDetailM(type) {
      switch (type) {
        case "todo":
          this.displayTodo = "block";
          break;
        case "done":
          this.displayDone = "block";
          break;
        default:
          this.displayTodo = "block";
          break;
      }
    },
    // 隐藏提示信息
    hideDetailM(type) {
      switch (type) {
        case "todo":
          this.displayTodo = "none";
          break;
        case "done":
          this.displayDone = "none";
          break;
        default:
          this.displayTodo = "none";
          break;
      }
    },
  },
};
</script>

<style scoped lang="less">
#myDay {
  .todo {
    width: 3.6rem;
    position: absolute;
    right: 5.28rem;
  }
  .done {
    width: 3.6rem;
    position: absolute;
    right: 0.75rem;
  }
}
</style>